/**
 * Project client
 *
 * Created by stefensuhat on 10/31/18 10:10 AM
 */


const alertDialog = {
    name: 'alertDialog',
    state: { content: null, loading: false },
    reducers: {
        create: (state, payload) => ({ ...state, content: payload }),
        remove: state => ({ ...state, content: null, loading: false }),
        loading: state => ({ ...state, loading: true }),
    },
};

export default alertDialog;
